module.exports = __webpack_public_path__ + "static/media/st88888 (1).b1ab5677.png";